import { render, staticRenderFns } from "./MarginProperty.vue?vue&type=template&id=31053400&"
import script from "./MarginProperty.vue?vue&type=script&lang=js&"
export * from "./MarginProperty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports